var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"primary-pink-button-container"},[_c('button',{staticClass:"primary-pink-button-button button ButtonSmall",on:{"click":_vm.onClick}},[_vm._v(" "+_vm._s(_vm.button)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }